import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const NumberedList = React.forwardRef((props, ref) => (
  <SvgIcon {...props} ref={ref} width="24" height="24" viewBox="0 0 24 24">
    <path d="M5.5 14.0714H6.97368V14.3929H6.23684V15.0357H6.97368V15.3571H5.5V16H7.71053V13.4286H5.5V14.0714ZM6.23684 9.57143H6.97368V7H5.5V7.64286H6.23684V9.57143ZM5.5 10.8571H6.82632L5.5 12.2071V12.7857H7.71053V12.1429H6.38421L7.71053 10.7929V10.2143H5.5V10.8571ZM9.18421 7.64286V8.92857H19.5V7.64286H9.18421ZM9.18421 15.3571H19.5V14.0714H9.18421V15.3571ZM9.18421 12.1429H19.5V10.8571H9.18421V12.1429Z" />
  </SvgIcon>
));

export default React.memo(NumberedList);
